/**
 * Payment Cancel Page
 * Shown when user cancels Stripe checkout
 */
import { useNavigate, useSearchParams } from 'react-router-dom';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';
import { Button } from '../../components/ui/button';

const PaymentCancel = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const rideId = searchParams.get('ride_id');

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md w-full text-center">
        <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-12 h-12 text-gray-400" />
        </div>
        
        <h2 className="text-2xl font-bold text-gray-800 mb-2">Payment Cancelled</h2>
        <p className="text-gray-600 mb-6">
          Your airport transfer booking was not completed.
          No charges have been made to your card.
        </p>

        <div className="space-y-3">
          {rideId && (
            <Button
              onClick={() => navigate('/ride/airport')}
              className="w-full bg-amber-500 hover:bg-amber-600"
            >
              <span className="flex items-center gap-2">
                <RefreshCw className="w-4 h-4" />
                Try Again
              </span>
            </Button>
          )}
          
          <Button
            onClick={() => navigate('/ride/book')}
            variant="outline"
            className="w-full"
          >
            <span className="flex items-center gap-2">
              <ArrowLeft className="w-4 h-4" />
              Back to Booking Options
            </span>
          </Button>
        </div>

        <p className="text-xs text-gray-500 mt-6">
          Need help? Contact support@liantiao.com
        </p>
      </div>
    </div>
  );
};

export default PaymentCancel;
